// export let API_URL = "http://localhost:3005/api";
export let API_URL = "https://api.jobcontact.ca/api";
// export let API_URL = "http://51.79.25.244:3005/api";